// AI Generated Pipe
import { Pipe, PipeTransform } from '@angular/core';
import { MON_ICONS } from '@layout/icons/icons.constants';

@Pipe({
    name: 'monIcons',
    standalone: false,
})
export class MonIconsPipe implements PipeTransform {
    transform (icon: string[]): any {
        let i;
        let result = MON_ICONS;
        for (i = 0; i < icon.length; i++) {
            // eslint-disable-next-line
            // @ts-ignore
            result = result[icon[i]];
        }
        return result;
    }
}
